import React from "react";
import { PRODUCT_LIST } from "@/data/catalog";
import { ProductCard } from "@/components/ProductCard";
import { SectionHeading } from "@/components/home/SectionHeading";
import { useCart } from "@/context/CartContext";
import { PRODUCTS, SUBSCRIBE_DISCOUNT } from "@/data/catalog";
import { formatPrice } from "@/lib/format";
import { RefreshCw } from "lucide-react";

export const ShopRange = () => {
  const { addItem } = useCart();
  const subPrice = PRODUCTS.patch.price * (1 - SUBSCRIBE_DISCOUNT);

  return (
    <section className="bg-[#F8F5EF] py-16 md:py-24" data-testid="shop-range">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <SectionHeading overline="Shop the range" title="Everything you need, nothing you don't" />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {PRODUCT_LIST.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}

          {/* Subscribe & Save card */}
          <div
            data-testid="product-card-subscribe"
            className="bg-[#6F503A] text-[#F8F5EF] rounded-3xl p-6 flex flex-col gap-5"
          >
            <div className="aspect-square rounded-2xl bg-[#F8F5EF]/10 flex items-center justify-center">
              <RefreshCw className="w-12 h-12 text-[#B8C4A3]" />
            </div>
            <div>
              <span className="text-xs font-semibold uppercase tracking-[0.12em] text-[#B8C4A3]">Save 15%</span>
              <h3 className="font-heading text-lg font-semibold mt-1">Subscribe &amp; Save</h3>
              <p className="text-sm text-[#F8F5EF]/70 mt-1">Patches delivered on repeat. Pause or cancel anytime.</p>
            </div>
            <div className="mt-auto flex items-center justify-between gap-2">
              <span className="font-heading text-xl font-semibold">{formatPrice(subPrice)}</span>
              <button
                data-testid="add-subscribe-patch"
                onClick={() => addItem(PRODUCTS.patch, { qty: 1, sellingPlan: "subscribe", interval: "4w" })}
                className="px-5 py-2.5 rounded-full bg-[#B8C4A3] text-[#6F503A] text-sm font-medium hover:bg-[#a7b48f] transition-colors"
              >
                Subscribe
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
